'use strict';

angular.module('amexReconciliationApp')
  .component('transactionApprovals', {
    templateUrl: 'scripts/views/components/transaction-approvals.html',
    bindings: {
      transaction: '<'
    },
    controller: function (SiteConfigModel, UserRepository) {

      var self = this;

      self.approvalEnabledForBcaManager = SiteConfigModel.approvalEnabledForBcaManager;
      self.approvalEnabledForCardManager = SiteConfigModel.approvalEnabledForCardManager;
      self.approvalEnabledForAccountingManager = SiteConfigModel.approvalEnabledForAccountingManager;
      self.approvalEnabledForCardmember = SiteConfigModel.approvalEnabledForCardmember;
      self.approvalUserNames = null;

      self.isAccountingManagerApproved = function() {
        return _.get(self.transaction, 'mutableTransactionProperties.accountingManagerApproved', false);
      };

      self.isCardManagerApproved = function() {
        return _.get(self.transaction, 'mutableTransactionProperties.cardManagerApproved', false);
      };

      self.isBcaManagerApproved = function() {
        return _.get(self.transaction, 'mutableTransactionProperties.bcaManagerApproved', false);
      };

      self.isCardmemberSubmitted = function() {
        return _.get(self.transaction, 'mutableTransactionProperties.cardmemberSubmitted', false);
      };

      self.getApprovalNamesTooltip = function() {
        if (self.approvalUserNames === null) {
          self.approvalUserNames = 'not null';
          var userIds = [self.transaction.mutableTransactionProperties.cardmemberSubmittedBy,
            self.transaction.mutableTransactionProperties.cardManagerApprovedBy,
            self.transaction.mutableTransactionProperties.bcaManagerApprovedBy,
            self.transaction.mutableTransactionProperties.accountingManagerApprovedBy];
          userIds = _.uniq(_.compact(userIds));
          if (_.isEmpty(userIds)) {
            self.approvalUserNames = null;
          } else {
            return UserRepository.fetchApprovalUserNames(userIds)
              .then(function (response) {
                self.approvalUserNames = mapUserNamesToRoles(response);
              })
              .catch(function () {
                self.approvalUserNames = null;
              });
          }
        }
      };

      function mapUserNamesToRoles(response) {
        var roleUserNames = {};
        roleUserNames['cardmemberUserName'] = response[self.transaction.mutableTransactionProperties.cardmemberSubmittedBy];
        roleUserNames['cardManagerUserName'] = response[self.transaction.mutableTransactionProperties.cardManagerApprovedBy];
        roleUserNames['bcaManagerUserName'] = response[self.transaction.mutableTransactionProperties.bcaManagerApprovedBy];
        roleUserNames['accountingManagerUserName'] = response[self.transaction.mutableTransactionProperties.accountingManagerApprovedBy];
        return roleUserNames;
      }
    }

  });


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/transactionApprovals.js
// module id = 483
// module chunks = 0